import { render } from "./Sidebar.vue?vue&type=template&id=50c29fcc&scoped=true&ts=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=50c29fcc&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c29fcc"]])

export default __exports__